/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".download-all-spinner[_ngcontent-%COMP%]{display:inline-block;vertical-align:middle}"];
export { styles as styles };
